import { RootState } from 'store/root-reducer';

export const reasonTemplateOptionsSelector = ({ reasonTemplate }: RootState) => reasonTemplate.templateOptions;

export const isFetchingReasonTemplateOptionsSelector = ({ reasonTemplate }: RootState) =>
  reasonTemplate.fetchTemplateStatus === 'pending';